import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import {Button} from "@material-ui/core";
import { CircularProgress } from '@material-ui/core';
import { format } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import constants from '../../../constants';
import NumberFormat from 'react-number-format';
import getProductType from './ProductType';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  colorPrimary: {
    backgroundColor: theme.palette.primary.main
  },
}))

export function TabPanel(props) {
  const classes = useStyles();
  const { title, data, children, value, index,isLoading,date,productType, firstName, lastName, carrier, faceAmount, ...other } = props;

  // pull reference id from title
  const referenceId = title.match(/((?:\w+-)+\w+)/g);
 const handleNotification= ()=> {
   props.setActiveLink(props.navlink.findIndex((a) => a.text === 'Activity Center'));
   props.history.push(`/ActivityCenter/${referenceId}`)
  }
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
      className="tab-panel"
    >
      {value === index && !isLoading ? 
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
          <div className={`tab-header ${classes. colorPrimary}`}>
            <img alt="CovrLogo MS" className='tab-icon' src={process.env.PUBLIC_URL + "/AdvisorImages/covr-logo-white.svg"} />
          </div>
          <div className='tab-data-section pt-4 pl-4'>
            <div className='tabs-data'>
              <h4><b>{title}</b></h4>
              <h6 className='grey-text' >{date && format(zonedTimeToUtc(date, constants.serverIANATimezoneString), 'MMMM dd, yyyy - hh:mm aa')}</h6>
              <h6 className='mt-4'><b>{productType ? getProductType(productType) : '' } {productType && ( firstName || lastName) && ' - '} {firstName || ''} {lastName || ''}</b></h6>
              <h6 className='grey-text'>
              {(faceAmount ? <NumberFormat displayType={'text'} prefix={'$'} value={faceAmount}
                 thousandSeparator={true}/> : '')} {faceAmount &&  carrier && ' - '}
               {carrier || ''}
              </h6>
              <p className='mt-4 mb-0' dangerouslySetInnerHTML={{ __html: data }}></p>
              <div className={"d-flex"}>
                <Button variant="contained"
                        size="medium"
                        color="primary"
                        onClick={() => handleNotification()}
                        className='mt-4'
                >
                  OPEN CASE
                </Button>
              </div>

            </div>
          </div>
        </Box>
      :
        <div className="d-flex justify-content-center p-5">
          <CircularProgress />
        </div>
      }
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Notifications/SubComponents/TabPanel.js